import React, { useEffect, useMemo, useState } from "react";
import ReactDOMServer from 'react-dom/server';
import { Link, Head, useForm } from "@inertiajs/inertia-react";
import Input from "@/Components/Input";
import Label from "@/Components/Label";
import Button from "@/Components/Button";
import ApplicationLogo from "@/Components/ApplicationLogo";
import Radio from '@/Components/Radio';
import { Inertia } from "@inertiajs/inertia";
import numberFormat from "@/helpers/numberFormat";
import DatePicker from "react-date-picker";
import dateHelper, { isJuly, isWeekend } from "@/helpers/date";

import '../../css/datepicker.css';
import 'react-calendar/dist/Calendar.css';
import { DateTime } from "luxon";
import { useUsersRegistrationContext } from "@/context/UsersRegistration";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
import { useAppContext } from "@/context/App";
import classNames from "classnames";

export const messagesPopUpYounger = {
    'cerogrado': <p>Por razones de seguridad, se permite el acceso a la pista de hielo únicamente a niños mayores de <strong>5 años</strong> ó <strong>más de un metro (1mt)</strong> de estatura. <br /> <strong>NO SE ACEPTAN CAMBIOS NI DEVOLUCIONES.</strong> <br /> Gracias por su comprensión.</p>,
    'trampolinepark': <p>Por razones de seguridad, se permite el acceso a los trampolines únicamente a niños mayores de <strong>5 años</strong> ó <strong>más de un metro (1mt)</strong> de estatura. <br /> <strong>NO SE ACEPTAN CAMBIOS NI DEVOLUCIONES.</strong> <br/> Gracias por su comprensión.</p>
}

export default function Welcome({
    store,
    branchOffice,
    date,
    quantity,
    type = 'individual',
    uuid,
    bulkOrder,
    scheduleTypes,
    holidays,
    areSchedulesAvailablesToday,
    maxTicketsStocks,
    ...props
}) {
    const { removeUsersRegistration } = useUsersRegistrationContext()
    const { isHoliday } = useAppContext();


    const { data, setData, processing, errors, reset, get } = useForm({
        quantity: uuid ? 1 : quantity,
        date,
        uuid
    });

    const maxIndividual = 9

    const [typeSelected, setTypeSelected] = useState(uuid ? scheduleTypes.find(scheduleType => scheduleType.duration === bulkOrder.bulk_sale.schedule_type_duration) : null);
    const [tabSelected, setTabSelected] = useState(type || 'individual');
    const [showScheduleType, setShowScheduleType] = useState(true)
    const [showGroupAlert, setShowGroupAlert] = useState(false)

    const getMinByType = (type) => {
        if (uuid) {
            return 1;
        }

        const minima = {
            'individual': 1,
            'group': typeSelected?.min_group_count || 10,
            'birthday': typeSelected?.min_group_count || 10,
            'skating_class': 1,
            'skating_class_monthly': 1,
            'default': 1
        }

        return minima[type] || minima['default'];
    }

    const getMaxByType = (type) => {
        if (uuid) {
            return 1;
        }

        const maxima = {
            'individual': 9,
            'group': maxTicketsStocks.quantity || 10,
            'birthday': maxTicketsStocks.birthday_quantity || 10,
            'skating_class': 1,
            'skating_class_monthly': 1,
            'default': 9
        }

        return maxima[type] || maxima['default'];
    }

    const canContinueToNextPage = useMemo(() => {
        const quantity = parseInt(data.quantity);

        const [min, max] = [getMinByType(type), getMaxByType(type)]
        if (quantity < min || quantity > max) return false;
        if (isNaN(quantity)) return false;

        return true;
    }, [data.quantity, type, typeSelected]);

    useEffect(() => {
        if (data.quantity !== quantity) {
            removeUsersRegistration();
        }

        if ((type === 'individual' || type === null) && parseInt(data.quantity) > maxIndividual) {
            setShowGroupAlert(true);
        } else {
            setShowGroupAlert(false);
        }
    }, [data.quantity, quantity])

    const popUpBirthdayCookieKey = 'is_displayed_alert_for_pop_up_birthday';

    useEffect(() => {
        if (type === 'birthday' && !Cookies.get(popUpBirthdayCookieKey)) {
            Swal.fire({
                icon: 'warning',
                title: 'Advertencia',
                html: 'Recuerda que para contratar tu cumpleaños debes realizarlo con el total de tus invitados para garantizar el aforo. <br /> <strong>SOLO SE PERMITE 5 APODERADOS POR CUMPLEAÑOS INCLUYENDO A LOS PADRES, NO ES UNA ZONA EXCLUSIVA</strong>'
            })

            Cookies.set(popUpBirthdayCookieKey, 'true', {expires: DateTime.now().plus({ hours: 1 }).toJSDate()});
        }
    }, [type])

    // useEffect(() => {
    //     console.log(!type && data.quantity > maxIndividual)
    //     console.log(data.quantity)

    //     setIsIndividual(!type && data.quantity > maxIndividual)
    // }, [data.quantity])

    const onHandleChange = (event) => {
        //setShowScheduleType(false)

        if (event.target.name === 'date') {
            const date = DateTime.fromFormat(event.target.value, 'yyyy-MM-dd').toJSDate();

            if (bulkOrder) {
                if (bulkOrder && !bulkOrder.is_weekend && (isWeekend(date) || isHoliday(date))) {
                    setData(event.target.name, data.date);
                    return;
                }
            }
        }
        setData(event.target.name, event.target.value);

        switch(event.target.name){
            case 'date':
                submitDate(event.target.value)
                break;
            case 'quantity':
                handleQuantity(event)
                break
        }
    };

    const handleQuantity = (event) => {
        //console.log(event.target.value, event.target.max)
        //setShowGroupAlert(true)
        // if(parseInt(event.target.value) > parseInt( event.target.max)){
        //     setShowGroupAlert(true)
        //     setIsIndividual(false)
        // }else{
        //     setShowGroupAlert(false)
        //     setIsIndividual(true)
        // }
        // if (type === 'individual') {
        //     if (parseInt(event.target.value) > parseInt( event.target.max)) {
        //         setShowGroupAlert(true);
        //         setCanContinue(false);
        //     } else {
        //         setShowGroupAlert(false);
        //         setCanContinue(true);
        //     }
        // } else {
        //     if (parseInt(event.target.value) > parseInt( event.target.max)) {
        //         setCanContinue(false);
        //     } else {
        //         setCanContinue(true);
        //     }
        // }


    }

    const handlePrice = (type) => {
        return (isWeekend(date) || isJuly(date) || isHoliday(date)) ? type.weekend_price : type.price
    }

    const submitDate = (_date) => {
        //e.preventDefault();
        return Inertia.visit(route("service.quantity-date-selector", {
            office: branchOffice.slug,
            type,
            date: _date,
            quantity: data.quantity,
            uuid
        }));
    };
    const handleNextStep = (e) => {
        e.preventDefault()
        if (typeSelected) {
            get(route('schedule.search', {
                office:branchOffice.slug,
                type,
                scheduleType: typeSelected.id,
                uuid,
            }))
        }
    }

    const handleTabGroup = (type, event) => {
        event.preventDefault()
        return Inertia.visit(route("service.quantity-date-selector", {
            office: branchOffice.slug,
            type,
            uuid
        }));
    }

    const disabled = data.quantity < 1 || data.date == "";
    const noScheduleTypeAvailable = !(branchOffice.schedule_types && scheduleTypes.length > 0)

    const popUpYoungerCookieKey = 'is_displayed_alert_for_pop_up_younger';

    useEffect(() => {
        if (!Cookies.get(popUpYoungerCookieKey)) {
            Swal.fire({
                icon: 'warning',
                title: 'Advertencia',
                html: ReactDOMServer.renderToStaticMarkup(messagesPopUpYounger[store])
            });

            Cookies.set(popUpYoungerCookieKey, 'true', {expires: DateTime.now().plus({ hours: 1 }).toJSDate()});
        }
    }, [])

    return (
        <>
            <Head title="Selección de horario - Cerogrado" />
            <div className="relative flex items-top justify-center min-h-screen bg-gray-100 sm:items-center sm:pt-0">
                <div className="max-w-6xl w-full mx-2 sm:mx-auto sm:px-6 lg:px-8 py-4">
                    <div className="flex justify-center pt-8 sm:pt-0">
                        <ApplicationLogo store={store} />
                    </div>

                    <div className="max-w-6xl mx-2 sm:mx-auto sm:px-6 lg:px-8 pt-4">
                        {!uuid && (
                            <div className="w-full grid grid-cols-2 sm:grid-cols-4 gap-3 mx-auto sm:max-w-lg mt-6 px-3 py-3 bg-white shadow-md overflow-hidden sm:rounded-lg">
                                <button
                                    onClick={(e) => {handleTabGroup('individual', e)}}
                                    className={classNames("px-3 py-1 rounded", {
                                        "bg-primary text-white font-bold": tabSelected === 'individual' && store === 'cerogrado',
                                        "bg-tp-primary text-black font-bold": tabSelected === 'individual' && store === 'trampolinepark',
                                        "bg-gray-200": !tabSelected
                                    })}
                                >
                                    Individual
                                </button>
                                <button
                                    onClick={(e) => {handleTabGroup('group', e)}}
                                    className={classNames("px-3 py-1 rounded", {
                                        "bg-primary text-white font-bold": tabSelected === 'group' && store === 'cerogrado',
                                        "bg-tp-primary text-black font-bold": tabSelected === 'group' && store === 'trampolinepark',
                                        "bg-gray-200": !tabSelected
                                    })}
                                >
                                    Grupal
                                </button>
                                <button
                                    onClick={(e) => {handleTabGroup('birthday', e)}}
                                    className={classNames("px-3 py-1 rounded", {
                                        "bg-primary text-white font-bold": tabSelected === 'birthday' && store === 'cerogrado',
                                        "bg-tp-primary text-black font-bold": tabSelected === 'birthday' && store === 'trampolinepark',
                                        "bg-gray-200": !tabSelected
                                    })}
                                >
                                    Cumpleaños
                                </button>
                                <button
                                    onClick={(e) => {handleTabGroup('skating_class', e)}}
                                    className={classNames("px-3 py-1 rounded", {
                                        "bg-primary text-white font-bold": tabSelected === 'skating_class' && store === 'cerogrado',
                                        "bg-tp-primary text-black font-bold": tabSelected === 'skating_class' && store === 'trampolinepark',
                                        "bg-gray-200": !tabSelected
                                    })}
                                >
                                    Clase
                                </button>
                            </div>
                        )}
                        {
                            <div className="mx-auto sm:max-w-lg mt-6 px-6 py-4 bg-white shadow-md sm:rounded-lg">
                                {(() => {
                                    const min = getMinByType(type);
                                    const max = getMaxByType(type);
                                    return (
                                        <>
                                            {!(min === 1 && max === 1) && (
                                                <h1 className="mb-4 text-center text-gray-900 text-lg font-bold">
                                                    ¿Cuantos tickets vas a llevar?
                                                </h1>
                                            )}
                                            <form onSubmit={submitDate}>
                                                {!(min === 1 && max === 1) && (
                                                    <div className="mb-4">
                                                            <>
                                                                <Label
                                                                    forInput="quantity"
                                                                    value="Número de tickets"
                                                                />
                                                                <Input
                                                                    type="number"
                                                                    min={min}
                                                                    max={max}
                                                                    name="quantity"
                                                                    value={data.quantity}
                                                                    className="mt-1 block w-full"
                                                                    isFocused={true}
                                                                    required={true}
                                                                    handleChange={onHandleChange}
                                                                    disabled={(type === 'skating_class' || type === 'skating_class_monthly') || noScheduleTypeAvailable}
                                                                />
                                                                {/* <p className="mt-1 text-xs text-gray-500">
                                                                    Compra de tickets para personas que utilicen
                                                                    juegos o trampolines hasta 120 kgs de peso.
                                                                </p> */}
                                                            </>
                                                        {
                                                            showGroupAlert && (
                                                                <div className="bg-amber-300 p-3 rounded">
                                                                    Si compras más de 9 tickets te recomendamos la compra <button className="font-bold underline" onClick={(e) => {handleTabGroup('group', e)}}>grupal</button>
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                )}

                                                <div>
                                                    <Label
                                                        forInput="date"
                                                        value="¿Cuándo quieres ir?"
                                                    />
                                                    {/* <Input
                                                        type="date"
                                                        name="date"
                                                        value={data.date}
                                                        className="mt-1 block w-full"
                                                        required={true}
                                                        handleChange={onHandleChange}
                                                        disabled={noScheduleTypeAvailable}
                                                    /> */}
                                                    <DatePicker
                                                        id="date"
                                                        minDate={DateTime.now().toJSDate()}
                                                        maxDate={(() => {
                                                            if (bulkOrder) {
                                                                const expirationDate = DateTime.fromSQL(bulkOrder.expiration_at).minus({ days: 1 }).toJSDate();
                                                                return expirationDate;
                                                            }
                                                            
                                                            return DateTime.now().plus({ years: 1 }).endOf('year').toJSDate();
                                                        })()}
                                                        calendarClassName="z-50"
                                                        className="mt-1 w-full"
                                                        value={DateTime.fromFormat(data.date, 'yyyy-MM-dd').toString()}
                                                        required
                                                        onChange={(date) => onHandleChange({target: {
                                                            name: 'date',
                                                            value: dateHelper.toString(date)
                                                        }})}
                                                        clearIcon={<></>}
                                                        disabled={noScheduleTypeAvailable}
                                                        tileDisabled={({ date }) => {
                                                            if (bulkOrder) {
                                                                if (bulkOrder.is_weekend) {
                                                                    return false;
                                                                } else {
                                                                    return isWeekend(date) || isHoliday(date);
                                                                }
                                                            }
                                                            return false;
                                                        }}
                                                        calendarIcon={<svg style={{ width: '14px' }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M152 24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H64C28.7 64 0 92.7 0 128v16 48V448c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V192 144 128c0-35.3-28.7-64-64-64H344V24c0-13.3-10.7-24-24-24s-24 10.7-24 24V64H152V24zM48 192H400V448c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192z"/></svg>}
                                                        format="dd/MM/yyyy"
                                                    />
                                                </div>
                                                {/* <div className="flex items-center justify-center mt-8"> */}
                                                    {/* {
                                                    !showScheduleType && <Button processing={processing || disabled}>
                                                        Buscar
                                                    </Button>
                                                    } */}
                                                {/* </div> */}
                                            </form>
                                        </>
                                    )

                            })()}

                            </div>
                        }

                    {
                        showScheduleType && branchOffice && scheduleTypes && scheduleTypes.length > 0 ?
                            <>

                                <div className="w-full mx-auto sm:max-w-lg mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg">
                                    <form className="mx-auto">
                                        <h2 className='mb-4 text-center text-gray-900 text-lg font-bold'>{uuid ? 'Período asignado' : 'Períodos disponibles'}</h2>
                                            {!uuid && (
                                                <>
                                                    {
                                                        tabSelected === 'individual' && scheduleTypes.filter(scheduleType => scheduleType.type === 'individual').map((type, key) => (
                                                            <Radio
                                                                key={key}
                                                                value={type}
                                                                binding={typeSelected}
                                                                name='schedule_type'
                                                                handleChange={(event)=> {
                                                                    setTypeSelected(type)
                                                                }}
                                                            >
                                                                {type.description} - ${numberFormat(type.price, 0, '', '.')} por persona
                                                            </Radio>
                                                        ))
                                                    }

                                                    {
                                                        tabSelected === 'group' && scheduleTypes.filter(scheduleType => scheduleType.type === 'group').map((type, key) => (
                                                            <Radio
                                                                key={key}
                                                                value={type}
                                                                binding={typeSelected}
                                                                name='schedule_type'
                                                                handleChange={(event)=> {
                                                                    setTypeSelected(type)
                                                                }}
                                                            >
                                                                {type.description} - ${numberFormat(type.price, 0, '', '.')} por persona
                                                            </Radio>
                                                        ))
                                                    }

                                                    {
                                                        tabSelected === 'birthday' && scheduleTypes.filter(scheduleType => scheduleType.type === 'birthday').map((type, key) => (
                                                            <Radio
                                                                key={key}
                                                                value={type}
                                                                binding={typeSelected}
                                                                name='schedule_type'
                                                                handleChange={(event)=> {
                                                                    setTypeSelected(type)
                                                                }}
                                                            >
                                                                {type.description} - ${numberFormat(type.price, 0, '', '.')} por persona
                                                            </Radio>
                                                        ))
                                                    }

                                                    {
                                                        (tabSelected === 'skating_class' || tabSelected === 'skating_class_monthly') && scheduleTypes.filter(scheduleType => (scheduleType.type === 'skating_class' || scheduleType.type === 'skating_class_monthly')).map((type, key) => (
                                                            <Radio
                                                                key={key}
                                                                value={type}
                                                                binding={typeSelected}
                                                                name='schedule_type'
                                                                handleChange={(event)=> {
                                                                    setTypeSelected(type)
                                                                }}
                                                            >
                                                                {type.description} - ${numberFormat(type.price, 0, '', '.')} por persona
                                                            </Radio>
                                                        ))
                                                    }
                                                </>
                                            )}

                                        {/* <div><pre><code>{JSON.stringify(typeSelected, null, 4)}</code></pre></div> */}
                                        {/* <div class="bg-blue-100 border-t border-b border-blue-500 text-blue-700 px-4 py-3" role="alert"> */}
                                        {uuid && (
                                            <div class="border-t border-b border-black px-4 py-3" role="alert">
                                                <p class="text-center font-bold">{typeSelected?.description}</p>
                                            </div>
                                        )}


                                        <div className="flex items-center justify-center mt-8 gap-4">
                                            <Link
                                                href={route('branch-office.selector', { uuid })}
                                                className={`inline-flex items-center px-4 py-2 bg-gray-900 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest active:bg-gray-900 transition ease-in-out duration-150`}
                                            >Volver</Link>
                                            <Button
                                                processing={!canContinueToNextPage}
                                                className={`p-3 ${!canContinueToNextPage ? 'bg-gray-400 cursor-not-allowed': 'bg-black'} text-white rounded`}
                                                onClick={handleNextStep}
                                            >Continuar</Button>
                                        </div>
                                    </form>
                                </div>
                            </>
                            :
                            <div className='text-center text-xl font-bold mt-8 text-gray-700'>

                                No tenemos horarios disponibles en esta sucursal.
                            </div>
                    }
                    </div>
                    {
                        type === 'birthday' &&
                        <div className="w-full text-center font-bold mx-auto sm:max-w-lg mt-6 px-6 py-4 bg-amber-400 shadow-md overflow-hidden sm:rounded-lg">
                            SOLO SE PERMITE 5 APODERADOS POR CUMPLEAÑOS INCLUYENDO A LOS PADRES, NO ES UNA ZONA EXCLUSIVA
                        </div>
                    }
                    <div className="w-full text-center mx-auto sm:max-w-lg mt-6 px-6 py-4 bg-white shadow-md overflow-hidden sm:rounded-lg">
                        {messagesPopUpYounger[store]}
                    </div>
                </div>
            </div>
        </>
    );
}
